// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getServerBaseUrl, getUrlParameter } from 'utils/urlUtils';
import app from 'config/app.json';

export const HEADER_CONTENTTYPE_APPJSON = 'application/json';
export const SKIP_AUTO_CONTENT_TYPE_HEADER = 'x-skip-auto-content-type-header';
export const CONTENT_TYPE_HEADER_NAME = 'content-type';
export const CONTEXT_PATH = window.REACT_APP_CONTEXT_PATH || '';

const baseQuery = fetchBaseQuery({
  baseUrl: getServerBaseUrl(),
  prepareHeaders: (headers, { getState }) => {
    if (
      !headers.has(SKIP_AUTO_CONTENT_TYPE_HEADER) ||
      headers.get(SKIP_AUTO_CONTENT_TYPE_HEADER) === 'false'
    ) {
      headers.append(CONTENT_TYPE_HEADER_NAME, HEADER_CONTENTTYPE_APPJSON);
    }

    const { token } = getState().auth;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }
});

const baseQueryWithApp = async (args, api, extraOptions) => {
  // AppCode Must be in uppercase
  const appCode = getUrlParameter(window.location, app.url.paramApp)?.toUpperCase();
  if (appCode) {
    let urlWithApp = typeof args === 'string' ? args : args.url;
    if (urlWithApp.indexOf('?') < 0) {
      urlWithApp += '?';
    } else {
      urlWithApp += '&';
    }
    urlWithApp += `${app.url.paramApp}=${appCode}`;
    return baseQuery(
      args === 'string' ? urlWithApp : { ...args, url: urlWithApp },
      api,
      extraOptions
    );
  }
  return baseQuery(args, api, extraOptions);
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithApp,
  endpoints: () => ({})
});
